import { Component, effect, inject, OnDestroy, TemplateRef, ViewChild, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

import { TranslateModule } from '@ngx-translate/core';

import { MpsLoaderService } from '../../services/mps-loader.service';

@Component({
  selector: 'mps-loader',
  templateUrl: './mps-loader.component.html',
  styleUrl: './mps-loader.component.scss',
  imports: [MatProgressSpinner, TranslateModule],
  encapsulation: ViewEncapsulation.None,
})
export class MpsLoaderComponent implements OnDestroy {
  @ViewChild('loaderTemplate', { static: true }) private loaderTemplate!: TemplateRef<unknown>;

  loader = inject(MpsLoaderService);

  private readonly overlay = inject(Overlay);
  private readonly viewContainerRef = inject(ViewContainerRef);
  private readonly overlayRef: OverlayRef = this.overlay.create({
    hasBackdrop: true,
    backdropClass: 'mps-loader-backdrop',
    panelClass: 'mps-loader-panel',
    positionStrategy: this.overlay.position().global().centerHorizontally().centerVertically(),
    disposeOnNavigation: true,
  });

  constructor() {
    effect(() => {
      if (this.loader.isLoading()) {
        if (!this.overlayRef.hasAttached()) {
          this.overlayRef.attach(new TemplatePortal(this.loaderTemplate, this.viewContainerRef));
        }
        return;
      }

      if (this.overlayRef.hasAttached()) {
        this.overlayRef.detach();
      }
    });
  }

  ngOnDestroy(): void {
    this.overlayRef.dispose();
  }
}
